import React from 'react';
import { SxStyle } from '../../../types';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const styles: SxStyle = {
  title: {
    display: 'flex',
    minHeight: '50px',
    alignItems: 'center',
    paddingX: 5,

    borderStyle: 'solid',
    borderWidth: '1px 0 0 0',
    borderColor: 'rgb(0, 0, 0, 12%)',

    '@media (max-width: 1100px)': {
      borderRightWidth: 0,
    },
  },
  container: {
    paddingY: 2,
    paddingX: 4,

    boxShadow: 'inset 0px 8px 5px -5px #0000001A',
    borderStyle: 'solid',
    borderWidth: 0,
    borderColor: 'rgb(0, 0, 0,5%)',

    '@media (max-width: 1100px)': {
      borderWidth: 0,
    },
  },
};

interface Props {
  title: string;
  divider?: boolean;
  children?: React.ReactNode;
}

const AppMenuColumn = ({ title, divider, children }: Props) => {
  return (
    <>
      <Box sx={{ ...styles.title, borderRightWidth: divider ? '1px' : 0 }}>
        <Typography variant="body2-bold">{title}</Typography>
      </Box>
      <Box sx={{ ...styles.container, borderRightWidth: divider ? '1px' : 0 }}>{children}</Box>
    </>
  );
};

export default AppMenuColumn;
